// https://zoomcharts.com/developers/en/geo-chart/api-reference/settings/layerTypes/items/style/node/customShape.html#doc_distanceToEdge
// https://zoomcharts.com/developers/en/net-chart/api-reference/settings/style/node.html#doc_display

// window.ZoomCharts.Internal.Base
//

// ImageShape / RhombusShape
//
//
// window.ZoomCharts.Internal.Base.SettingsInteraction
// t.SettingsInteractionSelection
// t.SettingsAdvanced
//
// https://zoomcharts.com/developers/en/net-chart/examples/style/custom-node-shapes.html

const ImageShape = window.ZoomCharts.Internal.ItemsChart.ImageShape;

let imageCache = {};

const customShape = {
  onUpdate: function(ctx, radius) {
    return {
      bounds: [-radius, -radius, radius, radius],
      HWidth: radius,
      HHeight: radius,
      anchor: [0, 0]
    };
  },
  paint: function(ctx, offsetX, offsetY, Hwidth, Hheight, image, shouldPaintDetails) {
    ctx.beginPath();
    ctx.fillStyle = this.fillColor;
    ctx.moveTo(offsetX + Hwidth, offsetY);
    ctx.arc(offsetX, offsetY, Hwidth, 0, Math.PI * 2, false);
    ctx.closePath();
    ctx.fill();

    const imageRadius = Hheight * 0.9;

    if (image) {
      if (! image.id) {
	image.id = Math.random()
      }

      let new_image = imageCache[image.id];
      if (! new_image) {
	console.log("Building new image", image);
	new_image = imageCache[image.id] = window.ZoomCharts.Internal.Base.Graphics.cropImageToCircle(image, "crop");
      }
     
      ctx.drawImage(new_image, offsetX - imageRadius, offsetY - imageRadius, imageRadius * 2, imageRadius * 2);
    }
  },
  distanceToEdge: function(r, w, ddx, ddy) {
    return r*1.25
  }
}

export { customShape };
